import React from 'react';
import { prettyDate } from '../../utils/strings';
import { Space } from '../utils/utils';
import styles from './timeline.module.scss';
import { IoCloudDownload } from 'react-icons/io5';
import { downloadActionDocument } from '../../network/measure';

const CTimeline = (props: any) => {
  const { documents } = props;

  return (
    <div className={styles.timeline}>
      {documents && documents.length === 0 && (
        <p className={`body-dark bold`}>Momentan nu există niciun document.</p>
      )}
      {documents && documents.length > 0 && (
        <p className='subheading-dark bold'>Istoric documente adăugate</p>
      )}
      {documents && documents.length > 0 && <Space vertical='5vh' />}
      {documents &&
        documents.map((document: any, index: number) => (
          <div className={styles.line} key={index}>
            <p>
              <span className='body-dark bold'>
                {index % 2 === 0
                  ? document.name
                  : prettyDate(document.createdAt)}
              </span>
              <br />
              <span className='small-dark'>
                {index % 2 === 0 ? document.description : ''}
              </span>
            </p>
            <div className='col'>
              <span className={styles.dot}>
                <IoCloudDownload
                  onClick={() =>
                    downloadActionDocument(document.id, document.name)
                  }
                />
              </span>
              {index < documents.length - 1 && (
                <span className={styles.separator} />
              )}
            </div>
            <p>
              <span className='body-dark bold'>
                {index % 2 === 1
                  ? document.name
                  : prettyDate(document.createdAt)}
              </span>
              <br />
              <span className='small-dark'>
                {index % 2 === 1 ? document.description : ''}
              </span>
            </p>
          </div>
        ))}
      {documents && documents.length > 0 && <Space vertical='5vh' />}
    </div>
  );
};

export default CTimeline;
